// app/frontend/components/Posts/CommentsList.tsx

import React from 'react';
import { Stack, Text } from '@mantine/core';
import CommentItem from './CommentItem';
import { CommentData, CommentFormData } from '../../types/comment';

interface CommentsListProps {
  comments: CommentData[];
  postId: number;
  isUserSignedIn?: boolean;
  onCommentSubmit?: (formData: CommentFormData) => Promise<void>;
}

const CommentsList: React.FC<CommentsListProps> = ({
  comments,
  postId,
  isUserSignedIn = true,
  onCommentSubmit = async () => {},
}) => {
  // Filter to only show top-level comments (those without parent_id)
  const topLevelComments = comments.filter((comment) => !comment.parent_id);

  if (!topLevelComments || topLevelComments.length === 0) {
    return (
      <Text color="dimmed" mt="md">
        No comments yet. Be the first to comment!
      </Text>
    );
  }

  return (
    <Stack gap="4px" mb="3rem">
      {topLevelComments.map((comment) => {
        // Find all direct replies to this comment
        const replies = comments.filter((reply) => reply.parent_id === comment.id);

        // Create a comment with its replies
        const commentWithReplies: CommentData = {
          ...comment,
          comments: replies.length > 0 ? replies : undefined,
        };

        return (
          <CommentItem
            key={comment.id}
            comment={commentWithReplies}
            postId={postId}
            isUserSignedIn={isUserSignedIn}
            onCommentSubmit={onCommentSubmit}
          />
        );
      })}
    </Stack>
  );
};

export default CommentsList;
